import React from 'react';
import { useParams } from 'react-router-dom';

import {
  PlaylistMarkdownPreview,
  useGetPlaylistContentQuery,
} from 'features/classCreation';
import ErrorLayout from 'components/ErrorLayout/ErrorLayout';
import Loader from 'components/Loader/Loader';

function PlaylistPreviewPage() {
  const { playlistId } = useParams();
  const { isLoading, data, error, refetch } = useGetPlaylistContentQuery(
    Number(playlistId)
  );

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load cue card content"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data) {
    const { data: playlistContentData } = data;
    const { article } = playlistContentData || {};
    const { content } = article || {};

    return (
      <div className="p-s">
        <PlaylistMarkdownPreview mdString={content} />
      </div>
    );
  }
}

export default PlaylistPreviewPage;
